export default __webpack_public_path__ + "static/media/include_4@2x.38a19ae5.jpg";